var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('KycDesktop',{attrs:{"ratio":1/4,"title":_vm.$t('kyc.titles.financial'),"next-button-theme":"primary","back-route":"/kyc/desktop/identity"},on:{"next":_vm.next}},[_c('FinancialContent',{staticClass:"mb-8"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }